import {
    ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES,
    ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_NOM,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_DATA_ALTA,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_TIPUS_ESTACIO,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI_AEMET,
    ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_OPERATIVA
} from '../../../../actions/actionTypes';

const estatNull = {
    codi: null,
    nom: null,
    dataAlta: null,
    dataBaixa: null,
    codiAEMET: null,
    operativa: false,
    idTipusEstacio: null
};
export const ESTAT_INICIAL = {
    originals: {...estatNull},
    editades: {...estatNull}
};

const dadesBasiques = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTRUCTURA_I_DADES:
            return {
                originals: action.estructuraIDades.dades.dadesBasiques,
                editades: action.estructuraIDades.dades.dadesBasiques
            };

        case ESTACIO_INTRODUCCIO_DESCARTAR_CANVIS:
            return {
                ...state,
                editades: state.originals
            };

        case ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_NOM:
            return {
                ...state,
                editades: {
                    ...state.editades,
                    nom: action.nom
                }
            };

        case ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI:
            return {
                ...state,
                editades: {
                    ...state.editades,
                    codi: action.codi
                }
            };

        case ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_DATA_ALTA:
            return {
                ...state,
                editades: {
                    ...state.editades,
                    dataAlta: action.dataAlta
                }
            };

        case ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_TIPUS_ESTACIO:
            return {
                ...state,
                editades: {
                    ...state.editades,
                    idTipusEstacio: action.idTipusEstacio
                }
            };

        case ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_CODI_AEMET:
            return {
                ...state,
                editades: {
                    ...state.editades,
                    codiAEMET: action.codiAEMET
                }
            };


        case ESTACIO_INTRODUCCIO_DADES_BASIQUES_MODIFICAR_OPERATIVA:
            return {
                ...state,
                editades: {
                    ...state.editades,
                    operativa: action.operativa
                }
            };

        default:
            return state;
    }
};

export default dadesBasiques;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/dades/dadesBasiques.js